import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../base/baseQuery'

export const authServiceApi = createApi({
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (credentials) => ({
        url: 'auth/login',
        method: 'POST',
        body: { email: credentials.username, password: credentials.password },
      }),
    }),
    signOut: builder.mutation({
      query: (token) => ({
        url: 'signout',
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
})

export const { useSignInMutation, useSignOutMutation } = authServiceApi
